import { uri } from 'utils';

import types from '../types';
import {
    getCheckboxGroupStateFromURL,
    getResetedCheckboxGroupState,
    getRadioStateFromURL
} from '.';

/**
 * @param {types.Filter[]} filters
 * @param  {string} url
 * @returns {boolean}
 */
const urlContainsFilter = (filters, url) => {
    const params = uri.getParams(url);
    const selectedFilters = filters.filter(filter => params[filter.id]);

    return !!selectedFilters.length;
};

/**
 * @typedef  {Object} Params
 * @property {types.Filter} filter
 * @property {types.Filter[]} filters
 * @property {string} url
 * @property {number} index
 */

/**
 * @param {Params}
 * @returns {types.Filter}
 */
const getFilterInitialStateByFilterType = ({ filter, filters, url, index }) => {
    switch (filter.type) {
        case 'checkbox': {
            const options = getCheckboxGroupStateFromURL(
                getResetedCheckboxGroupState(filter.options),
                url,
                filter.id
            );

            if (filter.radio && filter.radio.value) {
                if (!urlContainsFilter(filters, url) && index === 0) {
                    return {
                        ...filter,
                        options,
                        radio: {
                            ...filter.radio,
                            checked: true
                        }
                    };
                }

                return {
                    ...filter,
                    options,
                    radio: getRadioStateFromURL({
                        radio: filter.radio,
                        url,
                        filterId: filter.id
                    })
                };
            }

            return {
                ...filter,
                options
            };
        }

        case 'select': {
            const filterValueInURL = uri.getParams(url)[filter.id];

            if (!filterValueInURL) {
                return filter;
            }

            const { options } = filter;

            const availableOptionsValues = options.reduce(
                (acc, curr) => [...acc, curr.value],
                []
            );

            const urlFilterValueIsValid = availableOptionsValues.includes(
                filterValueInURL
            );

            if (!urlFilterValueIsValid) {
                return filter;
            }

            return {
                ...filter,
                value: filterValueInURL
            };
        }

        default: {
            return filter;
        }
    }
};

/**
 * Get state primarily by URL parameters with fallback to default values
 * @param {types.Filter[]} filters
 * @param {string} url
 * @returns {types.Filter[]}
 */
const getFiltersInitialStateFromURL = (filters, url) => {
    if (!filters || !Array.isArray(filters) || !filters.length) {
        return [];
    }

    return filters.map((filter, index) =>
        getFilterInitialStateByFilterType({ filter, filters, url, index }));
};

export default getFiltersInitialStateFromURL;
